import { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { Clock } from 'lucide-react';

export function LiveClock({ compact = false }: { compact?: boolean }) {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const easternTime = formatInTimeZone(
    currentTime,
    'America/New_York',
    'EEEE, MMMM d, yyyy • h:mm:ss a'
  );

  const timeZoneAbbr = formatInTimeZone(
    currentTime,
    'America/New_York',
    'zzz'
  );

  return (
    <div className={`flex items-center gap-2 text-sm text-muted-foreground bg-muted/30 px-4 py-2 rounded-lg ${compact ? '' : 'mb-6'}`}>
      <Clock className="w-4 h-4" />
      <span className="font-medium">{easternTime}</span>
      <span className="text-xs bg-primary/10 text-primary px-2 py-0.5 rounded-full">
        {timeZoneAbbr}
      </span>
    </div>
  );
}